import { verifyOffline, type OfflineState } from './offline';
import { PwaUpdate } from './updates';
export interface PwaCallbacks { offline:(state:OfflineState)=>void; update:()=>void; error:(message:string)=>void }
export async function registerPwa(callbacks:PwaCallbacks):Promise<PwaUpdate|null>{
  if(!('serviceWorker'in navigator)||!window.isSecureContext)return null;
  if(import.meta.env.DEV)return null;
  const update=new PwaUpdate();
  try{
    const registration=await navigator.serviceWorker.register('/sw.js',{scope:'/',updateViaCache:'none'});
    const waiting=():void=>{if(registration.waiting&&navigator.serviceWorker.controller){update.waiting=registration.waiting;callbacks.update();}};
    waiting();
    registration.addEventListener('updatefound',()=>{
      const worker=registration.installing;
      worker?.addEventListener('statechange',()=>{if(worker.state==='installed')waiting();});
    });
    const ready=await navigator.serviceWorker.ready;
    if(ready.active)callbacks.offline(await verifyOffline(ready.active));
    document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')void registration.update().catch(()=>{});});
    return update;
  }catch(error){callbacks.error(`Offline-Einrichtung fehlgeschlagen: ${String(error)}`);return update;}
}
